var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"button"},'div',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.$t('buttons.viewAll'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }